<template>
<!-- Product Start -->
<section id="products" class="product_sec">
    <div class="container-fuid px-2">
        <div class="row">
            <div class="col-sm-12 ">
                <h2 class="title text-center">Nos produits</h2>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Kit film PURE ZONE à poser soi-même</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/KIT-FILM-PURE-ZONE-A-POSER-SOI-MEME.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Pousse-porte anti bactérien</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/POUSSE-PORTE-ANTI-BACTERIEN.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Sous-mains PURE ZONE <br /> 115 × 35 cm</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/SOUS-MAINS-PURE-ZONE-1.15-X-0.35.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Sous-mains PURE ZONE <br /> 40 × 60 cm</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/SOUS-MAINS-PURE-ZONE-40X60cm.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Sous-mains PURE ZONE carte du monde <br /> 40 × 60 cm</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/SOUS-MAINS-PURE-ZONE-CARTE-MONDE-40x60.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Sous-mains PURE ZONE enfants & scolaire <br /> 40 × 60 cm</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/SOUS-MAINS-PURE-ZONE-ENFANT&SCOLAIRE-40X60CM.jpg" alt="produit"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 pb-4">
                <div class="products__product">
                    <div class="products__title">Sous-mains PURE ZONE gris <br /> 35 × 60 cm</div>
                    <img class="img-fluid img-full" src="../assets/images/produits/SOUS-MAINS-PURE-ZONE-GRIS-35X60C.jpg" alt="produit"/>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Product End -->
</template>

<script>
export default {
    name: 'product'
}
</script>



// WEBPACK FOOTER //
// src/components/product.vue